'use strict';

$ = jQuery;

/*
* Cliques em "Se inscrever" no YouTube na página de post
*/
$('.post-clique-incricao-youtube').on('click', function () {

  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Post',
    'eventAction': 'Clique - Inscrição',
    'eventLabel': 'Youtube'
  });

  gtag('event', 'Post', {
    'eventAction': 'Clique - Inscrição',
    'eventLabel': 'Youtube'
  });
});